import { render, staticRenderFns } from "./FortunePanel.vue?vue&type=template&id=2ce072cf&"
import script from "./FortunePanel.vue?vue&type=script&lang=js&"
export * from "./FortunePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports